export default {
    documentStatus: {
        complete: 'Complete',
        pending: 'Pending',
        error: 'Error',
    },
    containerStatus: {
        inTransit: 'In Transit',
        delivered: 'Delivered',
        delayed: 'Delayed',
        atPort: 'At Port',
    },
    riskLevel: {
        low: 'Low',
        medium: 'Medium',
        high: 'High',
        critical: 'Critical',
    },
    documentType: {
        billOfLading: 'Bill of Lading',
        invoice: 'Commercial Invoice',
        phytosanitaryCertificate: 'Phytosanitary Certificate',
        movementCertificate: 'EUR.1 Movement Certificate',
        packingList: 'Packing List',
        fumigationCertificate: 'Fumigation Certificate',
        sadIcm: 'SAD/ICM',
        coo: 'Certificate of Origin',
        unknown: 'Unknown Document',
    },
    roles: {
        authority: 'Authority',
        freightForwarder: 'Freight Forwarder',
        sales: 'Sales',
        spedizioniere: 'Forwarder',
        dogana: 'Customs',
        vettoreMarittimo: 'Maritime Carrier',
        trasportoTerrestre: 'Land Transport',
        portoImbarco: 'Port of Loading',
        portoSbarco: 'Port of Discharge',
        staffAeroporto: 'Airport Staff',
        armatore: 'Ship Owner',
    },
    status: {
        active: 'Active',
        pending: 'Pending',
        rejected: 'Rejected',
        suspended: 'Suspended',
        inactive: 'Inactive',
        accepted: 'Accepted',
        modified: 'Modified',
        confirmed: 'Confirmed',
        cancelled: 'Cancelled',
    },
    teamRoles: {
        admin: 'Admin',
        editor: 'Editor',
        viewer: 'Viewer',
    },
};

